













import { Component, Mixins } from 'vue-property-decorator';
import { ListingFilter } from 'client-website-ts-library/filters';
import { View } from 'client-website-ts-library/plugins';
import { WebsiteLevel } from 'client-website-ts-library/types';
import { Config } from 'client-website-ts-library/services';

import Listings from '../components/Listings.vue';
import ListingSearch from '../components/ListingSearch.vue';

@Component({
  components: {
    Listings,
    ListingSearch,
  },
})
export default class PropertiesForRent extends Mixins(View) {
  private listingFilter: ListingFilter | null = null;

  handleFilter(filter: ListingFilter) {
    this.listingFilter = filter;
    // eslint-disable-next-line no-param-reassign
    this.listingFilter.SearchLevel = WebsiteLevel.Office;
    // eslint-disable-next-line no-param-reassign
    this.listingFilter.SearchGuids.push('4e9814df-12f6-4c08-b411-1499c2b952c9');
    // eslint-disable-next-line no-param-reassign
    this.listingFilter.SearchGuids.push(Config.Website.Settings!.WebsiteId);
  }
}
